module.exports = __webpack_public_path__ + "img/American_Credit_Business_loans_the_Difference_You_can_Trust.2576ac7.png";